
import { Injectable } from '@angular/core';
import  clevertap from 'clevertap-web-sdk'

@Injectable({
    providedIn: 'root'
})

export class CleverTapService {
    clevertapCommonFunction(eventName, property) { 
        try {
            clevertap.event.push(eventName, property);
        }
        catch(e) {
            console.log(e,"clevertapPush");
        }        
    }    
}
